import { pick } from 'lodash-es'
import { useTbViewStore, useDetailStore } from '@vt/hooks'
import { useProjectValidator } from './tab'

export const useDefsInjector = (detail) => {
  const projectValidator = useProjectValidator()

  const { fields, ditto } = useTbViewStore((state) =>
    pick(state, ['fields', 'ditto'])
  )

  let currentData
  if (detail) {
    currentData = useDetailStore((state) => state.currentData)
  }

  const titleDefs = fields.find((f) => f.slug === 'title')
  // 行内编辑标题时重复性校验
  if (
    projectValidator('createRepeatlyCheck') &&
    (!titleDefs.repeatCheckSet || detail)
  ) {
    const repeatCheckSet = new Set()

    ditto.data.forEach((node) => {
      repeatCheckSet.add(node.title)
    })

    // 详情编辑时忽略当前数据
    if (currentData) {
      repeatCheckSet.delete(currentData.title)
    }

    titleDefs.repeatCheckSet = Array.from(repeatCheckSet)
  }
}
